import { RESET_LOADING, SET_LOADING, SET_THEME } from "../types"
import { Dispatch } from "redux"
// import ClientJS from "clientjs"

export const resetLoading = () => (dispatch: Dispatch) =>
  dispatch({ type: RESET_LOADING })
export const setLoading = () => (dispatch: Dispatch) =>
  dispatch({ type: SET_LOADING })
export const setTheme = (lightTheme: boolean) => (dispatch: Dispatch) =>
  dispatch({ type: SET_THEME, payload: lightTheme })

// export const setFingerprint = () => async (dispatch: Dispatch) => {
//   //eslint-disable-next-line no-undef
//   var client = new ClientJS() // Create A New Client Object

//   var fingerprint = client.getFingerprint() // Get Client's Fingerprint

//   console.log(fingerprint)

//   dispatch({
//     type: SET_PRINT,
//     payload: fingerprint,
//   })
// }
